import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../../config/themes/variables/mediaqueries';
import SummaryProfile from '../../../core/SummaryProfile';
import Education from '../../../core/Education';
import Buttons from '../../../core/Buttons';
import SkillUser from '../../../core/SkillUser';
import Projects from '../../../core/Projects';
import Experience from '../../../core/Experience';
import {
  LanguagesBackground,
  BikeBackground,
  VolunteerBackground,
  AwardsBackground
} from '../../../../../assets/images/index';
import HobbieUser from '../../../core/HobbieUser';
import AvatarPerson from '../../../core/AvatarPerson';

export const StyledSummaryProfile = styled(SummaryProfile)`
  clear: both;
  h2 {
    svg {
      margin-top: ${rem('-5px')};
    }
  }
`;

export const StyledBoxProjects = styled.div`
  background-color: ${props => props.theme.colors.grayLightest};
  padding: ${rem('25px')} ${rem('16px')} ${rem('30px')} ${rem('16px')};
  ${mediaqueries.greaterThan('mobile')`
    padding: ${rem('30px')} ${rem('24px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    padding: ${rem('30px')} 0;
  `};
`;

export const StyledProjects = styled(Projects)`
  margin: auto;
  max-width: ${rem('1232px')};
`;

export const StyledBoxCentral = styled.div`
  margin: 0 auto ${rem('30px')} auto;
  max-width: ${rem('1232px')};
  padding-top: ${rem('30px')};
  ${mediaqueries.greaterThan('mobile')`
    padding: 0 ${rem('25px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    padding: 0 ;
    margin-bottom: ${rem('60px')}
  `};
`;

export const StyledBoxExperienceInfo = styled.div`
  ${mediaqueries.greaterThan('desktop')`
    display: flex;
    justify-content: space-between;
  `};
`;

export const StyledBoxInfo = styled.div`
  margin: 0 ${rem('20px')};

  ${mediaqueries.greaterThan('mobile')`
    display: grid;
    grid-gap: 0 ${rem('20px')};
    grid-template-columns: 50% 50% ;
    width: calc(100% - ${rem('20px')});
    margin: 0;
  `};
  ${mediaqueries.greaterThan('desktop')`
    display: block;
    width: auto;   
  `};
`;

export const StyledButtonContainer = styled.div`
  margin: ${rem('19px')} auto ${rem('30px')} auto;
  max-width: ${rem('1232px')};
  padding-top: ${rem('30px')};
  ${mediaqueries.greaterThan('mobile')`
  padding: ${rem('35px')} ${rem('25px')} 0 ${rem('25px')};
`};
  ${mediaqueries.greaterThan('desktop')`
  padding: 0 ;
  margin-bottom: ${rem('60px')}
`};
`;

export const StyledProfileFlex = styled.div`
  display: ${props => (props.isWidget === true ? 'block' : 'flex')};
  justify-content: space-around;
  margin-top: ${props => props.isWidget !== true && '20px'};
  text-align: ${props => props.isWidget === true && 'center'};
`;

export const StyledProfileBlock = styled.div`
  display: ${props => (props.isWidget === true ? 'inline-block;' : 'block')};
  margin-left: ${props =>
    props.right === true && props.isWidget !== true && '-6%'};
  margin-right: ${props => props.left === true && '0%'};
  ${mediaqueries.lessThan('mobile')`
    margin-right: 0;
    margin-left: 5%;
  `}
  ${mediaqueries.lessThan('desktop')`
    margin-right: ${props => props.left === true && '20px'};
    margin-left: ${props => props.right === true && '0%'};
  `}
`;

export const StyledProfile = styled.figure`
  border-radius: 50%;
  box-shadow: 0 0 0 ${rem('1px')} ${props => props.theme.colors.dark},
    0 0 0 ${rem('4px')} ${props => props.theme.colors.light};
  height: ${rem('226px')};
  img {
    height: 100%;
    width: ${props => !props.full && '100%'};
  }
  margin-bottom: ${rem('40px')};
  margin-left: ${rem('5px')};
  margin-top: ${rem('15px')};
  overflow: hidden;
  width: ${rem('226px')};
  ${mediaqueries.lessThan('mobile')`
    height: ${rem('134px')};
    margin-bottom: ${rem('25px')};
    width: ${rem('134px')};
  `};
  ${mediaqueries.greaterThan('mobile')`
    margin-top: 2.5rem;
  `};
`;

export const StyledAvatarPerson = styled(AvatarPerson)`
  font-size: ${rem('21px')};
  border: none;
  width: 100%;
  height: 100%;
`;

export const StyledButtonAvatar = styled.div`
  margin: 0rem auto 1.5rem;
  border-radius: 3px;
  padding: 10px;
  width: 200px;
  max-width: ${rem('1232px')};
  padding-top: ${rem('30px')};
  background-color: ${props => props.theme.colors.secondary};
  color: ${props => props.theme.colors.light};
  text-align: center;
  cursor: pointer;
  ${mediaqueries.lessThan('mobile')`
    padding-top: ${rem('8px')};
    margin-top: ${rem('48px')};
    margin-bottom: ${rem('48px')};
  `}
  ${mediaqueries.greaterThan('mobile')`
    padding-top: ${rem('8px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    padding-top: ${rem('10px')};
    margin-bottom: ${rem('60px')};
`};
`;

export const StyledButton = styled(Buttons)`
  z-index: 10;
  ${mediaqueries.greaterThan('mobile')`
    margin: 0 0 ${rem('15px')} ${rem('25px')};
    float: right;
`};
`;

export const StyledWrapEmployeeInfo = styled.div`
  background-color: ${props => props.theme.colors.grayLighter};
  margin-bottom: ${rem('30px')};
  ${mediaqueries.greaterThan('mobile')`
    margin-bottom: ${rem('20px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    margin-bottom: ${rem('40px')};
    width: ${rem('351px')};
  `};
`;

export const StyledWrapEmployeeInfoInterest = StyledWrapEmployeeInfo.extend`
  background-image: linear-gradient(
      75deg,
      ${props => props.theme.colors.grayLighter},
      rgba(255, 255, 255, 0)
    ),
    url(${LanguagesBackground});
`;

export const StyledWrapEmployeeInfoLanguages = StyledWrapEmployeeInfo.extend`
  background-image: linear-gradient(
      75deg,
      ${props => props.theme.colors.grayLighter},
      rgba(255, 255, 255, 0)
    ),
    url(${BikeBackground});
`;

export const StyledWrapEmployeeInfoVolunteer = StyledWrapEmployeeInfo.extend`
  background-image: linear-gradient(
      75deg,
      ${props => props.theme.colors.grayLighter},
      rgba(255, 255, 255, 0)
    ),
    url(${VolunteerBackground});
`;

export const StyledWrapEmployeeInfoAwards = StyledWrapEmployeeInfo.extend`
  background-image: linear-gradient(
      75deg,
      ${props => props.theme.colors.grayLighter},
      rgba(255, 255, 255, 0)
    ),
    url(${AwardsBackground});
`;

export const StyledBoxDual = styled.div`
  margin: 0 ${rem('20px')};

  ${mediaqueries.greaterThan('tablet')`
    margin: 0;
  `};

  ${mediaqueries.greaterThan('desktop')`
    display: flex;
    justify-content: space-between;
  `};
`;

export const StyledExperience = styled(Experience)`
  margin: 0 auto ${rem('30px')};
  padding: 0 ${rem('16px')};

  ${mediaqueries.greaterThan('mobile')`
    padding: 0 0 0 ${rem('19px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    margin-right: ${rem('85px')};
    padding: 0;
    width: 100%;
  `};
`;

export const StyledEducation = styled(Education)`
  margin-bottom: ${rem('30px')};
  background: ${props => props.theme.colors.grayLightest};
  ${mediaqueries.greaterThan('desktop')`
    margin: 0 ${rem('18px')} 0 0;
    width: 50%;
  `};
`;

export const StyledSkillUser = styled(SkillUser)`
  background: ${props => props.theme.colors.grayLightest};
  ${mediaqueries.greaterThan('desktop')`
    margin: 0 0 0 ${rem('18px')};
    width: 50%;
  `};
`;

export const StyledHobbiesUser = styled(HobbieUser)`
  background: ${props => props.theme.colors.grayLightest};
  ${mediaqueries.greaterThan('desktop')`
    width: 50%;
  `};
`;

export const StyledProfileName = styled.h2`
  margin: ${rem('30px')} ${rem('16px')} ${rem('20px')} ${rem('16px')};
  max-width: ${rem('1232px')};
  font-size: ${rem('20px')};
  font-family: ${props => props.theme.fonts.bold};
  text-transform: uppercase;
  color: ${props => props.isWidget === true && props.theme.colors.light};
  ${mediaqueries.greaterThan('mobile')`
    margin: ${rem('50px')} ${rem('24px')} ${rem('24px')};
    font-size: ${rem('28px')};
    line-height: normal;
  `};
  ${mediaqueries.greaterThan('desktop')`
    padding: 0;
    width: 100%;
    margin: ${rem('50px')} auto ${rem('24px')};
  `};
`;

export const StyledProfileDpto = styled.h3`
  margin: ${rem('0px')} ${rem('16px')} ${rem('20px')} ${rem('16px')};
  max-width: ${rem('1232px')};
  font-size: ${props => (props.isWidget === true ? rem('10px') : rem('16px'))};
  font-family: ${props => props.theme.fonts};
  font-weight: ${props => props.isWidget === true && '400'};
  text-transform: uppercase;
  color: ${props => props.isWidget === true && props.theme.colors.light};
  ${mediaqueries.greaterThan('mobile')`
    margin: ${rem('0px')} ${rem('24px')} ${rem('24px')};
    font-size: ${rem('16px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    padding: 0;
    width: 100%;
    margin: ${rem('0px')} auto ${rem('24px')};
  `};
`;

export const StyledProfileImg = styled.img`
  width: 50px;
  height: 50px;
`;

export const StyledLink = styled.a`
  margin: 0rem auto 1.5rem;
  border-radius: 3px;
  padding: 10px;
  max-width: ${rem('1232px')};
  padding-top: ${rem('30px')};
  background-color: ${props => props.theme.colors.secondary};
  color: ${props => props.theme.colors.light};
  text-align: center;
  cursor: pointer;
  display: block;
  ${mediaqueries.lessThan('mobile')`
    padding-top: ${rem('8px')};
    margin-top: ${rem('32px')};
  `}
  ${mediaqueries.greaterThan('mobile')`
    padding-top: ${rem('8px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    padding-top: ${rem('10px')};
    margin-bottom: ${rem('60px')};
  `};
`;
